import React from 'react';
import PropTypes from 'prop-types';
import exact from 'prop-types-exact';
import { compose } from 'recompose';
import {
  Col,
  Grid,
  Row,
  Button,
  ButtonToolbar,
  Clearfix,
  ButtonGroup,
} from 'react-bootstrap';

import TicketUploadSubmissionModal, {
  uploadSubmissionItemModalPropTypes,
  withUploadSubmissionItemModalState,
} from '../../tickets/attachments/TicketUploadSubmissionModal';
import TicketAttachmentsTableModal, {
  attachmentsModalPropTypes,
  withAttachmentsModalState,
} from '../../tickets/attachments/TicketAttachmentsTableModal';
import TicketAttachmentUploadModal, {
  uploadAttachmentsModalPropTypes,
  withUploadAttachmentsModalState,
} from '../../tickets/attachments/TicketAttachmentUploadModal';
import ConfirmModal, {
  confirmModalPropTypes,
  withConfirmModalState,
} from '../../confirmModal/confirmModal';

import Overlay from '../../../components/Overlay';

import TicketFacts from '../../tickets/components/TicketFacts';
import TicketUserHourSummary from '../../tickets/components/TicketUserHourSummary';
import TicketSubmissionItemViewer from '../../tickets/components/TicketSubmissionItemViewer';
import TicketVariablesEditor from '../../tickets/components/TicketVariablesEditor';
import FormWrapperEnhanced from '../../forms/TicketEntry/components/FormWrapperEnhanced';
import TicketStatus from '../../tickets/components/TicketStatus';
import JobFacts from '../../tickets/components/JobFacts';
import TicketCaluclatedFields from '../../tickets/components/TicketCalculatedFields';
import './style.css';


const propTypes = exact({
  openTicketEntryForm: PropTypes.any,
  ticketId: PropTypes.number.isRequired,
  canEdit: PropTypes.bool.isRequired,
  viewer: PropTypes.bool.isRequired,
  jobId: PropTypes.number.isRequired,

  isJobMutable: PropTypes.bool.isRequired,
  immutableReason: PropTypes.string,
  canDeleteTickets: PropTypes.bool.isRequired,
  showReplaceButton: PropTypes.bool.isRequired,

  deleteTicketAction: PropTypes.func.isRequired,
  ...attachmentsModalPropTypes,
  ...uploadAttachmentsModalPropTypes,
  ...uploadSubmissionItemModalPropTypes,
  ...confirmModalPropTypes,
});

const DetailsProcessor = (props) => {
  const { openTicketEntryForm, ticketId, canEdit, jobId, viewer } = props;
  const {
    showViewAttachmentsModal, closeViewAttachmentsModal, openViewAttachmentsModal,
  } = props;

  const {
    showSubmissionItemModal, closeUploadSubmissionItemModal, openUploadSubmissionItemModal,
  } = props;

  const {
    showUploadAttachmentsModal, closeUploadAttachmentsModal, openUploadAttachmentsModal,
  } = props;

  const {
    showModal, openModal, closeModal,
  } = props;

  const {
    deleteTicketAction, isJobMutable, canDeleteTickets, immutableReason, showReplaceButton,
  } = props;

  const overlayMessage = (immutableReason) || '';

  return (
    <Grid fluid>
      <Row>
        <Col xs={6}>
          <TicketSubmissionItemViewer ticketId={ticketId} />
        </Col>
        <Col xs={6}>
          <Row>
            <Col md={12}>
              <div className="panel panel-default">
                <TicketStatus ticketId={ticketId} />
              </div>
            </Col>
          </Row>
          <Row>
            <Col md={12}>
              <div className="panel panel-default">
                <TicketFacts ticketId={ticketId} />
              </div>
            </Col>
          </Row>
          <div className="panel panel-default">
            <TicketUserHourSummary viewer={viewer} ticketId={ticketId} />
          </div>
          <Row>
            <Col md={7}>
              <div className="panel panel-default">
                <div className="panel-body">
                  <TicketVariablesEditor ticketId={ticketId} disabled={!canEdit} />
                </div>
              </div>
            </Col>
            <Col md={5}>
              <div className="panel panel-default">
                <div className="panel-body">
                  <TicketCaluclatedFields ticketId={ticketId} />
                </div>
              </div>
            </Col>
          </Row>
          <div className="panel panel-default">
            <JobFacts ticketId={ticketId} />
          </div>
          <Clearfix>
            <ButtonToolbar className="pull-right">
              {canDeleteTickets && (
                <div className="inline-btn-styling">
                  <Overlay enabled={!isJobMutable} message={overlayMessage}>
                    <div className="tooltip-area">
                      <Button disabled={!isJobMutable} bsStyle="danger" onClick={openModal}>
                        Delete Ticket
                      </Button>
                    </div>
                  </Overlay>
                </div>
              )}
              <ButtonGroup>
                {showReplaceButton && (
                  <Button disabled={viewer} onClick={openUploadSubmissionItemModal}>
                    Replace Ticket
                  </Button>
                )}
                <Button onClick={openViewAttachmentsModal}>
                  View Attachments
                </Button>
                <Button disabled={viewer} onClick={openUploadAttachmentsModal}>
                  Upload Attachment
                </Button>
              </ButtonGroup>
              {canEdit && (
                <Button
                  bsStyle="primary"
                  onClick={openTicketEntryForm}
                > Edit Ticket
                </Button>
              )}
            </ButtonToolbar>
          </Clearfix>
        </Col>
      </Row>
      <div>
        <TicketUploadSubmissionModal
          onHide={closeUploadSubmissionItemModal}
          show={showSubmissionItemModal}
          ticketId={ticketId}
        />
        <TicketAttachmentsTableModal
          show={showViewAttachmentsModal}
          onHide={closeViewAttachmentsModal}
          ticketId={ticketId}
        />
        <TicketAttachmentUploadModal
          show={showUploadAttachmentsModal}
          onHide={closeUploadAttachmentsModal}
          ticketId={ticketId}
        />
        <FormWrapperEnhanced
          jobId={jobId}
          ticketId={ticketId}
          canEdit={canEdit}
        />
        <ConfirmModal
          show={showModal}
          onHide={closeModal}
          title="Delete Ticket"
          message="Are you sure you want to delete this ticket?"
          confirmButtonText="Confirm"
          confirmAction={() => { return deleteTicketAction(ticketId); }}
        />
      </div>
    </Grid>
  );
};

DetailsProcessor.propTypes = propTypes;


const enhance = compose(
  withAttachmentsModalState,
  withUploadAttachmentsModalState,
  withUploadSubmissionItemModalState,
  withConfirmModalState,
);

export default enhance(DetailsProcessor);
